import { dataUserCombinedSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserCombinedSolid = /*#__PURE__*/createIcon(dataUserCombinedSolid)
export default IconUserCombinedSolid
